import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit, OnDestroy {
  @ViewChild('header', { read: ElementRef }) public readonly headerRef: ElementRef;

  @Input('pageTitle') public title: string;
  @Input('pageTitleWithoutTranslate') public titleWithoutTranslate;
  @Input('subtitle') public subtitle: string;
  @Input('pageinfo') public pageinfo: string;
  @Input('template') public template: string = 'list';
  @Input('tabbed') public tabbed: boolean = false;
  @Input('contentFullHeight') public contentFullHeight: boolean;
  @Input('loader') public loader: boolean = true;
  @Input('iframe') public iframe: boolean = false;

  constructor() {}

  ngOnInit(): void {
  }

  ngOnDestroy(): void {}

  public enableLoader(): void {
    this.loader = true;
  }

  public disableLoader(): void {
    this.loader = false;
  }

}
